export class OffersSettingDtoSearchCriteria
{
  public Id:String;
}